import { render, staticRenderFns } from "./Enigma13.vue?vue&type=template&id=18dbbae2&scoped=true&"
import script from "./Enigma13.vue?vue&type=script&lang=js&"
export * from "./Enigma13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dbbae2",
  null
  
)

export default component.exports